<template>
  <section>
    <div class="row">
      <div class="col">
        <h4 class="text-center">
          <span>本會創會董事長<br><sup>上</sup>淨<sup>下</sup>空老和尚<br>圓寂兩週年追思紀念</span>
        </h4>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-img center :src="`${second_anniversary_file_url}/001.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">紹繼師承和尚心行</h4>
        <h4 class="text-center">廣弘傳燈佛陀教育</h4>
        <b-img center :src="`${second_anniversary_file_url}/002.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">住真實慧</h4>
        <h4 class="text-center">開化顯示真實之際</h4>
        <h4 class="text-center">惠以真實之利</h4>
        <b-img center :src="`${second_anniversary_file_url}/003.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">淨極光通達 寂照含虛空</h4>
        <h4 class="text-center">卻來觀世間 猶如夢中事</h4>
        <b-img center :src="`${second_anniversary_file_url}/004.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h4 class="text-center">淨空老和尚圓寂二週年追思紀念會</h4>
        <h5>2024-07-12：「座談會三：淨宗護法居士與友會代表追思老和尚」：</h5>
        <p class="h6"><a :href="`${second_anniversary_file_url}/2024-07-12.mp4`">督導 阮貴良居士 出席參加及發言</a></p>
        <h5>2024-07-13：「座談會四：淨宗儒釋道代表追思老和尚」：</h5>
        <p class="h6"><a :href="`${second_anniversary_file_url}/2024-07-13.mp4`">董事長 釋密寶法師 出席參加及發言</a></p>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)

export default {
  name: "second-anniversary",
  props: {
    // 
  },
  data() {
    return {
      second_anniversary_file_url: 'https://www2.budaedu.org/official-website-data/founder/anniversary-memorial-ceremony/second-anniversary'
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>